import { invertMap } from '@/sections/insights/queryBuilder/entities/common/invert';
import {
  getNotFromSimpleFilter,
  getOperatorFromQueryFilter,
  getOperatorFromSimpleFilter,
  getValueFromQueryFilter,
  getValueFromSimpleFilter,
} from '@/sections/insights/queryBuilder/entities/common/translators';
import type {
  SimpleFilter,
  SimpleFilterDefinition,
} from '@/sections/insights/queryBuilder/entities/types';
import type { QueryFilter } from '@/types';

const operatorMap: Record<string, string> = {
  'STARTS WITH': 'is',
};

const operatorMapInverse: Record<string, string> = {
  is: 'STARTS WITH',
};

// Define value map once
const valueMap: Record<string, string> = {
  O: 'Open',
  T: 'Triaged',
  C: 'Closed',
  A: 'Accepted',
  R: 'Remediated',
};

// Create inverse automatically
const valueMapInverse = invertMap(valueMap);

/**
 * Reusable field definition for Risk status
 * Translates between API codes and UI values
 */
export const RiskStatus: SimpleFilterDefinition = {
  apiField: 'status',
  uiField: 'Status',
  inputType: 'dropdown',
  getAvailableValues: () =>
    Promise.resolve(['Open', 'Triaged', 'Closed', 'Accepted', 'Remediated']),
  operators: ['is', 'is not'],

  translateForUI: (queryFilter: QueryFilter): SimpleFilter => {
    return {
      field: 'Status',
      operator: getOperatorFromQueryFilter(queryFilter, operatorMap),
      value: getValueFromQueryFilter(valueMap, queryFilter),
    };
  },

  matchesQueryFilter: (queryFilter: QueryFilter): boolean => {
    return (
      queryFilter.field === 'status' && queryFilter.operator === 'STARTS WITH'
    );
  },

  translateForAPI: (simpleFilter: SimpleFilter): QueryFilter => {
    return {
      field: 'status',
      operator: getOperatorFromSimpleFilter(simpleFilter, operatorMapInverse),
      value: getValueFromSimpleFilter(valueMapInverse, simpleFilter),
      not: getNotFromSimpleFilter(simpleFilter),
    };
  },
};
